import "./DesignOptionGroup.css";
import React from "react";

const DesignOptionGroup = React.memo(
  ({
    index,
    singleGroup,
    selected,
    handleOptionChange,
    notSelectablePPOCodes,
    dependentConflictRules,
  }) => {
    return (
      <div className="OptionGroup__container" key={`design-op-group-${index}`}>
        <h4 className="OptionGroup__title">{singleGroup["group"]}</h4>
        <div className="OptionGroup__items">
          {singleGroup["options"].map((option, index) => {
            const isDisabled = notSelectablePPOCodes.includes(option?.code);
            const dependentOnCode =
              dependentConflictRules?.[option?.code]?.dependentOn;
            const conflictList =
              dependentConflictRules?.[option?.code]?.conflictsWith || [];

            return (
              <label
                key={`${index}-${option?.code}`}
                className={`OptionGroup__item${
                  selected[singleGroup["group"]]?.code === option?.code
                    ? " selected"
                    : ""
                }${isDisabled ? " disabled" : ""}`}
              >
                <input
                  type="radio"
                  name={singleGroup["group"]}
                  onChange={() =>
                    handleOptionChange(singleGroup["group"], option)
                  }
                  checked={
                    selected[singleGroup["group"]]?.code === option?.code
                  }
                  disabled={isDisabled}
                  className="OptionGroup__radio"
                />
                <span className="OptionGroup__label">
                  {option?.name}
                  {dependentOnCode && (
                    <>
                      <br />
                      <span
                        style={{
                          color:
                            selected[singleGroup["group"]]?.code ===
                            option?.code
                              ? "gainsboro"
                              : "grey",
                          fontStyle: "italic",
                          fontWeight: "normal",
                          textTransform: "none",
                        }}
                      >
                        Only available with{" "}
                        {dependentConflictRules?.[dependentOnCode]?.name ||
                          dependentOnCode}
                      </span>
                    </>
                  )}
                  {conflictList.length > 0 && (
                    <>
                      <br />
                      <span
                        style={{
                          color: "grey",
                          fontStyle: "italic",
                          fontWeight: "normal",
                          textTransform: "none",
                        }}
                      >
                        Unavailable with{" "}
                        {conflictList
                          .map(
                            (single) =>
                              dependentConflictRules?.[single]?.name || single,
                          )
                          .join(", ")}
                      </span>
                    </>
                  )}
                </span>
              </label>
            );
          })}
        </div>
      </div>
    );
  },
);

export default DesignOptionGroup;
